<div class="form-header">
  <span *ngIf="edited.id && edited.id > 0">Edit</span>
  <span *ngIf="!edited.id || edited.id === -1">Add</span>
  <span *ngIf="panel === 0"> team</span>
  <span *ngIf="panel === 1"> team calendar</span>
  <span *ngIf="panel === 2"> team capabilities</span>
</div>

<form [formGroup]="practitionerGroupForm" (ngSubmit)="onSubmitForm(practitionerGroupForm)" >
  
<div class="dialog-container" *ngIf="panel === 0">
  <div class="field" required>
    <mat-form-field>
      <mat-label>Team name</mat-label>
      <input matInput formControlName="name" maxlength="50" name="name">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <mat-label>Description</mat-label>
      <textarea class="description-field" rows="4" columns="50" maxlength="255" matInput formControlName="description" name="description"></textarea>
    </mat-form-field>
  </div>
  <div class="table-container">
    <div class="table-label">Team Members</div>
      <div class="user-list">
        <table mat-table [dataSource]="userInfo" class="user-table">
          <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayColumns;"></tr>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>Email</th>
            <td mat-cell *matCellDef="let element; let index = index" >{{element.value.email}}
            </td>
          </ng-container>
          <ng-container matColumnDef="teamRole">
            <th mat-header-cell *matHeaderCellDef>Team Role</th>
            <td class="select-cell" mat-cell *matCellDef="let element; let index = index"  >
              <mat-select class="ckl-item" name="teamRole" [formControl]="getControl(index,'teamRole')" >
                <mat-option *ngFor="let role of getTeamRoles()" [value]="role">{{role}}</mat-option>
              </mat-select>
            </td>
          </ng-container>
          <ng-container matColumnDef="capabilities">
            <th mat-header-cell *matHeaderCellDef>Service Capabilities</th>
            <td class="select-cell" mat-cell *matCellDef="let element; let index = index"  >
               <mat-select [disabled]="isEvaluationTeam()" class="ckl-item" name="capabilities" [formControl]="getControl(index,'capabilities')" multiple>
                <mat-option *ngFor="let capability of familyServices" [value]="capability">
                  {{capability.name}} ({{getServiceLevelName(capability.serviceLevelId)}})
                </mat-option>
              </mat-select> 
            </td>
          </ng-container>

        </table>
    </div>
  </div>
</div>
<div class="dialog-container" *ngIf="panel === 1" >
  <div class="field" required >
    <mat-form-field appearance="fill">
      <mat-label>Work days</mat-label>
      <mat-select  formControlName="workDays" multiple>
        <mat-option *ngFor="let day of allDays" [value]="day">{{day}}</mat-option>
      </mat-select>
      <mat-hint>Working time is necessary for the scheduler to know when appointments can be made.</mat-hint>
    </mat-form-field>
  </div>
  <div class="half-field-container">
    <div class="half-field" required >
      <mat-form-field appearance="fill">
        <mat-label>Normal start time</mat-label>
        <mat-select  formControlName="startTime" >
          <mat-option *ngFor="let t of getStartTimeList()" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="half-field" required >
      <mat-form-field appearance="fill">
        <mat-label>Normal end time</mat-label>
        <mat-select  formControlName="endTime" >
          <mat-option *ngFor="let t of getEndTimeList()" [value]="t">{{t}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="date-field" required >
    <mat-form-field appearance="fill">
      <mat-chip-grid #chipList aria-label="Choose a date" (click)="picker.open()">
        <mat-chip-row
          *ngFor="let value of getHolidays()"
          [selectable]="false"
          [removable]="true"
          (removed)="remove(value)"
        >
          {{ value | date }}
          <mat-icon matChipRemove *ngIf="true">cancel</mat-icon>
        </mat-chip-row>
        <input
          [value]="resetModel"
          matInput
          [matDatepicker]="picker"
          placeholder="Choose a date"
          (dateChange)="dateChanged($event)"
          [matChipInputFor]="chipList"
          hidden
        />
      </mat-chip-grid>
      <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker
        #picker
        [startAt]="init"
        [dateClass]="dateClass"
      ></mat-datepicker>
    </mat-form-field>
  </div>
</div>

<div class="button-container">
  <button class="dialog-button" [disabled]="isFormInValid()" type="submit" mat-flat-button color="primary" >Save</button>
  <button class="dialog-button" *ngIf="panel > 0"  type="button" (click)="onPrevious()" mat-flat-button color="primary" >Previous</button>
  <button class="dialog-button" *ngIf="panel  < 1"   type="button" (click)="onNext()" mat-flat-button color="primary" >Next</button>
  <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
</div>


</form>
